var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, isValidElement } from "react";
import classNames from "classnames";
import { Button } from "../Button";
import { Icon } from "../Icon";
import DrawerNestedContent from "./DrawerNestedContent";
import DrawerAccordion from "./DrawerAccordion";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-drawerItem",
};
const DrawerItem = (_a) => {
    var { onClick, iconName, label, className, rightIcon, children, description, menuLayout } = _a, rest = __rest(_a, ["onClick", "iconName", "label", "className", "rightIcon", "children", "description", "menuLayout"]);
    const classList = classNames("tecma-drawer-item", className);
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const handleClick = (e) => {
        if (menuLayout) {
            setSubMenuOpen(true);
        }
        if (onClick) {
            onClick(e);
        }
    };
    return (_jsxs(_Fragment, { children: [children && menuLayout !== "page" ? (_jsx(DrawerAccordion, { headerIcon: iconName, headerLabel: label, children: children })) : (_jsxs(Button, Object.assign({ onClick: handleClick, iconName: iconName, className: classList, color: "transparent", iconSize: "medium" }, rest, { children: [_jsxs("span", { className: "item-text-container", children: [_jsx("span", { children: label }), description && _jsx("span", { className: "item-description", children: description })] }), rightIcon && isValidElement(rightIcon) ? (rightIcon) : (_jsx(Icon, { className: "tecma-drawer-item-right-icon", iconName: rightIcon }))] }))), children && menuLayout === "page" && (_jsx(DrawerNestedContent, { label: label, open: subMenuOpen, onNestedDrawerClose: () => setSubMenuOpen(false), children: _jsx("div", { onClick: () => setSubMenuOpen(false), onKeyDown: () => setSubMenuOpen(false), role: "button", tabIndex: 0, children: children }) }))] }));
};
DrawerItem.defaultProps = defaultProps;
export default React.memo(DrawerItem);
